import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"

import axios from "axios"
import { Provider } from "react-redux"
import { applyMiddleware, createStore } from "redux"
import { composeWithDevTools } from "redux-devtools-extension"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import thunk from "redux-thunk"
import env from "./env"
import reducers from "./reducers/reducers"

import Hotjar from '@hotjar/browser';

const siteId = 3621935;
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);

const queryClient = new QueryClient();

const store = createStore(reducers, composeWithDevTools(applyMiddleware(thunk)))
switch (env) {
  case 'production':
    axios.defaults.baseURL = "https://server.pagdeal.com.br"
    break;
  case 'local':
    axios.defaults.baseURL = "http://localhost:3001"
    break;
  case 'development':
    axios.defaults.baseURL = "https://server-dev.pagdeal.com.br"
    break;
  default:
    alert('URL invalida...')
}
// if ( === "production") {
//   axios.defaults.baseURL = "https://server.pagdeal.com.br"
// } else {
//   axios.defaults.baseURL = "http://localhost:3001"
// }

let user = localStorage.getItem("user")
if (typeof user === "string") {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.code && error.code === "ERR_CANCELED") {
        return Promise.reject(error)
      }

      let { url } = error?.response?.config
      if (error.response?.status === 401 && url !== "/signin") {
        localStorage.removeItem("user")
        window.location.href = "/"
      }
      return Promise.reject(error)
    },
  )
}

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <QueryClientProvider client={queryClient}>
  <Provider store={store}>
    {/* <React.StrictMode> */}
    <App />
    {/* </React.StrictMode> */}
  </Provider>
  </QueryClientProvider>
)
